import 'style/style.scss';


$(document).ready(() => {

    var isTouchDevice = 'ontouchstart' in document.documentElement;

    if (!isTouchDevice) {
        if ($('.aqua').length) {
            var grass = $('.js-grass'),
                fish = $('.js-fish');

            document.body.addEventListener('mousemove', animationsHandler);

            // Animate Elements
			function animationsHandler(e) {
				var decimalX = e.clientX / window.innerWidth - 0.5;
                var decimalY = e.clientY / window.innerHeight - 0.5;
                
				TweenMax.to(fish, 0, { 
                    force3D: true,
                    rotationY: 10 * decimalX, 
                    rotationX: 10 * decimalY,
                    x: 40 * decimalX,
                    y: 40 * decimalY,
                    rotationZ: '-0.1', 
                    transformPerspective: 500, 
                    transformOrigin:'center center',
                    ease: Quad.easeOut
                });

                TweenMax.to(grass, 0.1, { 
                    force3D: true,
                    x: 15 * decimalX,
                    rotationZ: '-0.1', 
                    transformPerspective: 500, 
                    transformOrigin:'center center',
                    ease: Quad.easeOut
                });
            }
        }

        if ($('.nature'.length)) {
            var $flowers = $('.js-flowers'),
                $bug = $('.js-bug'),
                $bugFace = $('.js-bug-face'),
                $bcg = $('.js-bcg');

            // Check if IE
            var ua = window.navigator.userAgent;
            var is_ie = /MSIE|Trident/.test(ua);

            // Animate Elements
            var windowWidth = $(window).innerWidth();
            var windowHeight = $(window).innerHeight();
            var halfWindowWidth = windowWidth / 2;
            var halfWindowHeight = windowHeight / 2;
            var bodyEl = $('body');
            
            function mouseMovement(moveAmount) {
                bodyEl.mousemove(function(e) {
                    var cursorX = e.pageX;
                    var cursorY = e.pageY;
                    var moveX = (cursorX - (halfWindowWidth)) * -moveAmount;
                    var moveY = (cursorY - (halfWindowHeight)) * -moveAmount;
                    var rotateY = moveX * -0.09;
                    var rotateX = moveY * -0.09;

                    TweenMax.to($bug, 1.175, {
                        x: moveX * 0.45,
                        y: moveY * 0.45,
                        rotationY: rotateY,
                        rotationX: rotateX,
                        transformPerspective: 500, 
                    });
                    TweenMax.to($bugFace, 1.175, {
                        x: -moveX * 0.3,
                        y: -moveY * 0.3,
                        rotationY: rotateY,
                        rotationX: rotateX,
                        transformPerspective: 500, 
                    });

                    // Disable multiple animations on IE
                    if ( is_ie ) {
                        console.log('ie');
                    } else {
                        TweenMax.to($flowers, 0.5, {
                            x: -moveX * 0.3
                        });
                    }
                })
            }
            mouseMovement(0.02);
        }
    } else {
        // Position Variables
        var x = 0;
        var y = 0;

        // Speed - Velocity
        var vx = 0;
        var vy = 0;

        // Acceleration
        var ax = 0;
        var ay = 0;

        var delay = 0;
        var vMultiplier = 0.5;

        if (window.DeviceMotionEvent == undefined) {
            document.getElementById("no").style.display = "block";
            document.getElementById("yes").style.display = "none";
        } else {
            window.ondevicemotion = function(event) {
                ax = event.accelerationIncludingGravity.x;
                ay = event.accelerationIncludingGravity.y;
                console.log("Accelerometer data - x: " + event.accelerationIncludingGravity.x + " y: " + event.accelerationIncludingGravity.y + " z: " + event.accelerationIncludingGravity.z);
            };

            setInterval(function() {
                vy = vy + -ay;
                vx = vx + ax;

                var ball = document.getElementById("ball");
                var grass = document.getElementById("grass");
                var fish = document.getElementById("fish");
                y = parseInt(y + vy * vMultiplier);
                x = parseInt(x + vx * vMultiplier);

                if (x < 0) {
                    x = 0;
                    vx = 0;
                }
                if (y < 0) {
                    y = 0;
                    vy = 0;
                }
                if (x > document.documentElement.clientWidth - 20) {
                    x = document.documentElement.clientWidth - 20;
                    vx = 0;
                }
                if (y > document.documentElement.clientHeight - 20) {
                    y = document.documentElement.clientHeight - 20;
                    vy = 0;
                }

                TweenLite.to(ball, 0.6, {
                    force3D: true,
                    y: -y / 65,
                    x: x / 75
                });
                TweenLite.to(grass, 0.6, {
                    force3D: true,
                    x: -x / 25
                });
                TweenLite.to(fish, 0.6, {
                    force3D: true,
                    y: y / 35,
                    x: x / 30
                });

                parallaxPos.x = curve(smoothX(-event.accelerationIncludingGravity.x / 10)) * 12;
                parallaxPos.y = curve(smoothY(-event.accelerationIncludingGravity.y / 10)) * 3;
            }, delay);
        }
    }
});


// WEBPACK FOOTER //
// ./static/js/index.js